<h1 mat-dialog-title>{{ 'common.reportType.title' | translate }}</h1>
<form class="calibrates-theme">

  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'common.reportType.options.cols' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div fxFlex="100" fxLayout="column">
        <div fxFlex="100">
          <mat-checkbox (change)="onChangeOptionsCheck($event)" [(ngModel)]="selectedCols">
            {{ 'common.reportType.options.selected.cols' | translate }}
          </mat-checkbox>
        </div>
        <mat-selection-list [(ngModel)]="data.calibrationPlan.cols" [ngModelOptions]="{standalone: true}" [disabled]="data.isSignature">
          @for (item of cols; track item) {
            <mat-list-option checkboxPosition="before" [value]="item.col">
              {{item.name}}
            </mat-list-option>
          }
        </mat-selection-list>
      </div>

    </mat-expansion-panel>
  </mat-accordion>

  <br /><br />

  <div mat-dialog-actions class="calibrates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>{{ 'button.download' | translate }}</button>
    @if(showSignBtn()) {
      <button mat-raised-button color="primary" (click)="openSignManual()">{{ 'button.sign-manual' | translate }}</button>
    }

    @if(!data.calibrationPlan.hasManual && showSignBtn()) {
      <button mat-raised-button color="primary"  (click)="openDialogSigner()">{{ 'button.sign-automatic' | translate }}</button>
    }
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>